import styled from 'styled-components';
import Theme from '../../../styles/models/theme';

export const Container = styled.div<{
  isCurrentUser?: boolean;
  hasAttachments?: boolean;
}>`
  flex-direction: ${({isCurrentUser}) =>
    isCurrentUser ? 'row-reverse' : 'row'};
  align-self: ${({isCurrentUser}) =>
    isCurrentUser ? 'flex-end' : 'flex-start'};
  max-width: 100%;
  align-items: flex-end;
  margin: 8px;
`;

export const InnerContainer = styled.div<{isCurrentUser?: boolean}>`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
`;

export const MessageContainer = styled.div<{isCurrentUser?: boolean}>`
  margin-left: ${isCurrentUser => (isCurrentUser ? '10px' : '8px')};
  margin-right: ${isCurrentUser => (!isCurrentUser ? '0px' : '8px')};
`;

export const DateText = styled.p<{theme?: Theme; isCurrentUser?: boolean}>`
  display: flex;
  justify-content: ${({isCurrentUser}) =>
    isCurrentUser ? 'flex-end' : 'flex-start'};
  color: ${({theme}) => theme.grayText};
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  margin-bottom: 5px;
  margin-right: ${({isCurrentUser}) => (isCurrentUser ? '10px' : '0px')};
`;

export const FogMessage = styled.div<{
  isCurrentUser?: boolean;
  hasAttachments?: boolean;
  theme?: Theme;
}>`
  padding: 10px 14px;
  border-radius: 16px;
  ${({isCurrentUser}) =>
    !isCurrentUser
      ? 'border-top-left-radius: 2px'
      : 'border-bottom-right-radius: 2px'};
  background-color: ${({isCurrentUser, theme}) =>
    isCurrentUser
      ? theme.messageSendedBackground
      : theme.messageReceivedBackground};
  justify-content: center;
  min-height: 40px;
`;

export const MessageText = styled.h1<{theme?: Theme; isCurrentUser?: boolean}>`
  color: ${({theme, isCurrentUser}) =>
    isCurrentUser ? theme.darkText : theme.darkText};
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 16px;
`;
